var _circle, _circle2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnpublishListingIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 141,
    viewBox: "0 0 142 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.9118,
    cy: 70.4118,
    r: 70.4118,
    fill: "#E3E9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.0012,
    cy: 70.4114,
    r: 20.2434,
    fill: "url(#paint0_linear_1817_145798)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9132 102.8C94.4343 102.8 117.385 70.4109 117.385 70.4109C117.385 70.4109 94.4343 38.0215 70.9132 38.0215C47.3921 38.0215 24.4414 70.4109 24.4414 70.4109C24.4414 70.4109 47.3921 102.8 70.9132 102.8ZM70.9132 90.1262C81.8017 90.1262 90.6285 81.2994 90.6285 70.4109C90.6285 59.5224 81.8017 50.6956 70.9132 50.6956C60.0247 50.6956 51.1979 59.5224 51.1979 70.4109C51.1979 81.2994 60.0247 90.1262 70.9132 90.1262Z",
    fill: "url(#paint1_linear_1817_145798)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.913 98.5775C90.8703 98.5775 110.344 70.4128 110.344 70.4128C110.344 70.4128 90.8703 42.248 70.913 42.248C50.9557 42.248 31.4824 70.4128 31.4824 70.4128C31.4824 70.4128 50.9557 98.5775 70.913 98.5775ZM70.913 90.1281C81.8015 90.1281 90.6283 81.3012 90.6283 70.4128C90.6283 59.5243 81.8015 50.6975 70.913 50.6975C60.0246 50.6975 51.1977 59.5243 51.1977 70.4128C51.1977 81.3012 60.0246 90.1281 70.913 90.1281Z",
    fill: "url(#paint2_linear_1817_145798)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.182 63.6625C58.9507 65.6165 58.2383 67.9303 58.2383 70.4104C58.2383 77.4102 63.9127 83.0846 70.9124 83.0846C73.3926 83.0846 75.7064 82.3722 77.6603 81.1408L60.182 63.6625ZM81.6433 77.1576C82.8743 75.2038 83.5865 72.8903 83.5865 70.4104C83.5865 63.4107 77.9121 57.7363 70.9124 57.7363C68.4326 57.7363 66.1191 58.4485 64.1653 59.6796L81.6433 77.1576Z",
    fill: "#3EE78D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1817_145798",
    x1: 64.8953,
    y1: 47.285,
    x2: 64.8953,
    y2: 118.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A3495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1817_145798",
    x1: 56.8961,
    y1: 33.4087,
    x2: 56.8961,
    y2: 114.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1817_145798",
    x1: 73.4429,
    y1: 103.506,
    x2: 73.4429,
    y2: 34.5027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1130A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4A6CEC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublishListingIc);
export default __webpack_public_path__ + "static/media/unpublish-listing-ic.968e93b40e2258843980457695703eb8.svg";
export { ForwardRef as ReactComponent };